import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import { WifiInformationModel } from '@dch/products-business-logic';
import { WifiInformationEntity } from '../configs/entity.config';
import { CustomerService } from '@proximus/ng-common';
import { map, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class WifiInformationService {
  constructor(private customerService: CustomerService) {}

  getWifiInformation(payload: any): Observable<IEntity<WifiInformationModel>> {
    return this.getCustomerId().pipe(
      switchMap((customerId) => this.fetchWifiInformation(customerId, payload)),
    );
  }

  private fetchWifiInformation(
    customerId: string,
    payload: any,
  ): Observable<IEntity<WifiInformationModel>> {
    return EntityManager.getEntity<WifiInformationModel>(
      WifiInformationEntity,
      {
        customerId,
        circuitId: payload.circuitId,
      },
    );
  }

  private getCustomerId(): Observable<string> {
    return this.customerService.getCustomerAccount().pipe(
      take(1),
      map((customerAccount) => customerAccount.getSelectedCustomer()),
      map(({ customerId }) => String(customerId)),
    );
  }
}
